import { Injectable } from '@angular/core';
import { Observable, ReplaySubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PusherEventService {
  private events: Map<string, Subject<any>>;

  constructor() {
    this.events = new Map<string, Subject<any>>();
  }

  watchEvent(key: string): Observable<any> {
    if (!this.events.has(key)) {
      this.events.set(key, new Subject<any>());
    }
    return this.events.get(key).asObservable();
  }

  bindEvent(key: string, value: any) {
    if (!this.events.has(key)) {
      this.events.set(key, new Subject<any>());
    }
    this.events.get(key).next(value);
  }
}
